import React from 'react';
import { Box, Heading, Text, Flex, useColorModeValue } from '@chakra-ui/react';
import { Settings } from 'lucide-react';
import Page from '../../layout/IntegraAppPage';

const Configuracoes = () => {
  const corDeFundo = useColorModeValue('white', 'gray.800');
  const corDaBorda = useColorModeValue('gray.200', 'gray.700');
  const corTextoSecundario = useColorModeValue('gray.500', 'gray.400');

  return (
    <Page>
      {/* TÍTULO DA PÁGINA */}
      <Box mb={6}>
        <Heading size="lg">Configurações</Heading>
        <Text fontSize="sm" color={corTextoSecundario}>
          Configurações gerais do sistema
        </Text>
      </Box>

      {/* CARD CENTRAL */}
      <Box
        bg={corDeFundo}
        border="1px solid"
        borderColor={corDaBorda}
        borderRadius="2xl"
        minH="300px"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Flex direction="column" align="center" gap={3}>
          <Settings size={40} color="gray" />

          <Text fontWeight="500">Módulo de Configurações</Text>

          <Text fontSize="sm" color={corTextoSecundario} textAlign="center">
            Configurações da empresa, preferências e integrações
          </Text>
        </Flex>
      </Box>
    </Page>
  );
};

export default Configuracoes;
